// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagUpdateModel extends SmartTagModel {
	timeframe?: string;

	constructor() {
		super();
		this.timeframe = '';
	}
}

export class SmartTagUpdate extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagUpdateModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagUpdateModel): void{
		const title = data.title || data.subCategory || '';
		const timeframe = data.timeframe || '';
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		if (timeframe !== '') {
			this.addText(`<span title="${timeframe}">Timeframe: ${timeframe}</span>`);
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
